export default __webpack_public_path__ + "84052c4398178d23ae59cfdfd4c1a4e3.png";